import { render, staticRenderFns } from "./listdemo.vue?vue&type=template&id=5e0fb884&"
import script from "./listdemo.vue?vue&type=script&lang=js&"
export * from "./listdemo.vue?vue&type=script&lang=js&"
import style0 from "./listdemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0fb884')) {
      api.createRecord('5e0fb884', component.options)
    } else {
      api.reload('5e0fb884', component.options)
    }
    module.hot.accept("./listdemo.vue?vue&type=template&id=5e0fb884&", function () {
      api.rerender('5e0fb884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/listdemo.vue"
export default component.exports